import {TreeConfig} from './tree.model';
import {UserPermissions} from './user-permissions.model';

export type ProjectEntity = TreeConfig & UserPermissions;
